<template lang="pug">
	.radio-campaigns
		Dashboard(mode='campaign')
</template>

<script>
import Dashboard from './Dashboard.vue';

export default {
	translationCategory: 'reconciliation.RadioCampaigns',
	components: {
		Dashboard
	}
};
</script>
<style lang="scss">
	.radio-campaigns {
		@import "main/themes/generated/variables.base.scss";

	}
</style>
